export default {
  common: {
    clearAll: 'Очистить ВСЕ',
    required: 'Требуется',
    restart: 'Перезапустить'
  },
  createUser: {
    acceptTermsAndConditions: 'Принять положения и условия',
    alreadyHaveAccount: 'Уже есть аккаунт? %{pre}Скачать%{post}',
    checkEmail: 'Тем временем, загрузите Metrica Play на свой компьютер',
    clubCompany: 'Организация/клуб',
    createdSuccessfully:
      'Регистрация прошла успешно! Проверьте зарегистрированную электронную почту на наличие проверочной ссылки. (Проверьте папку со спамом)',
    email: 'Электронная почта',
    invalidEmail: 'Неверная электронная почта',
    job: 'Должность/Роль',
    lastName: 'Фамилия',
    name: 'Имя',
    noCustomOption: 'Опция недоступна',
    noMatches: 'Нет совпадений, напишите свой вариант',
    password: 'Пароль',
    passwordsDontMatch: 'Пароли не совпадают',
    passwordInvalid: 'Пароль не соответствует требованиям',
    passwordRequirements: {
      minLength: 'Не менее %{count} символов',
      uppercase: 'Одна заглавная буква',
      lowercase: 'Одна строчная буква',
      number: 'Одна цифра (0-9)',
      maxLength: 'Максимальное число символов: %{count}'
    },
    phone: 'Телефон',
    phoneCode: 'Страна',
    proceed: 'Действуйте',
    repeatPassword: 'Повторите пароль',
    searchPhoneCode: 'Поиск...',
    seeTermsAndConditions: 'См. положения и условия',
    signAgreement:
      'Регистрация учетной записи в Metrica Sports означает, что вы соглашаетесь с %{pre1}Политикой Конфиденциальности%{post1} и %{pre2}Условиями Обслуживания%{post2}',
    signUpHere: 'Создайте аккаунт, чтобы начать.',
    sport: 'Спорт',
    submitting: 'Начало...',
    title: 'Начните с %{product}',
    userKeyField: 'У вас есть промо-код или ключ пользователя? Заполните это поле'
  },
  error: {
    downloadPlay:
      'Если у вас уже есть учетная запись, загрузите последнюю версию Play и войдите в систему.',
    emailTaken: 'Это письмо уже было получено',
    fieldTooLong: 'Некоторые поля слишком длинные. Сократите их и попробуйте снова',
    oops: 'Упс!',
    restart: 'Похоже, вы пытаетесь влезть в то, что мы все еще разрабатываем...',
    tryAgain:
      'Пожалуйста, попробуйте еще раз, если эта ошибка продолжается, обратитесь в службу поддержки Metrica Sports',
    userKey:
      'Ключ не действителен. Проверьте ключ и повторите попытку или удалите поле для завершения регистрации'
  },
  invitation: {
    acceptButton: 'Принимаю Изменение Моего Аккаунта',
    accepting: 'Принимая...',
    cancelButton: 'Отклонить',
    description1:
      'Когда вас добавят в новый аккаунт Metrica Sports, владение вашим текущим аккаунтом Metrica Sports (и содержащейся в нем информацией) будет передано и назначено новому владельцу аккаунта Metrica Sports. Вся информация и данные, в настоящее время содержащиеся в вашем аккаунте Metrica Sports, а также любая информация или данные, сохраненные после того, как вы примете изменение аккаунта, будут видны и доступны новому владельцу аккаунта Metrica Sports и любому администратору(ам) этого аккаунта для использования и обмена с другими по усмотрению владельца аккаунта.',
    description2:
      'Нажимая на "Acepto el cambio de mi cuenta", вы соглашаетесь и авторизуете следующее:',
    list1:
      'Информация вашей текущей учетной записи будет перенесена в новую учетную запись Metrica Sports.',
    list2:
      'Вся информация учетной записи, перенесенная в ваш новый аккаунт Metrica Sports из вашего текущего аккаунта, может быть управляема новым владельцем аккаунта и/или администратором(ами).',
    list3:
      'В новом аккаунте Metrica Sports ваша роль будет «Член». Вы больше не будете иметь привилегии владельца или администратора от вашего текущего аккаунта.',
    list4:
      'Вы унаследуете существующие настройки вашего нового аккаунта Metrica Sports, которые могут быть более или менее ограничительными в зависимости от вашей роли в аккаунте, и ваши настройки могут управляться новым владельцем или администратором(ами) аккаунта Metrica Sports.',
    list5:
      'Ваши текущие настройки могут быть изменены, если они конфликтуют с настройками нового аккаунта, к которому вы присоединяетесь.',
    list6:
      'Возможно, ваш новый аккаунт не предоставит доступ ко всем функциям, которые есть в вашем текущем аккаунте.',
    list7:
      'Невозможно отменить перевод вашего аккаунта после его инициации, и вся информация об аккаунте останется в одном аккаунте.',
    list8:
      'Нажимая на кнопку «Я Принимаю Изменение Моего Аккаунта», вы становитесь управляемым членом аккаунта %{pre1}%{email}%{post1} и соглашаетесь с %{pre2}Условиями Службы%{post2} и %{pre3}Заявлением о Конфиденциальности%{post3} от Metrica Sports.',
    subtitle:
      'Приняв это новое приглашение на аккаунт Metrica Sports, вы будете добавлены в другой аккаунт Metrica Sports.',
    title: 'Приглашение'
  },
  jobs: {
    academyDirector: 'Директор Академии',
    assistantCoach: 'Помощник тренера',
    dataAnalyst: 'Аналитик данных',
    doctor: 'Врач',
    formerPlayer: 'Бывший игрок',
    goalkeeperCoach: 'Тренер вратарей',
    headCoach: 'Тренер',
    journalist: 'Журналист',
    other: 'Другое',
    performance: 'Производительность и фитнес',
    player: 'Игрок',
    scout: 'Скаут',
    sportsDirector: 'Спортивный директор',
    student: 'Ученик',
    videoAnalyst: 'Аналитик видео'
  },
  sports: {
    americanFootball: 'Американский футбол',
    baseball: 'Бейсбол',
    basketball: 'Баскетбол',
    fieldHockey: 'Хоккей на траве',
    football: 'Футбол/Футбол',
    futsal: 'Футзал',
    gaelicFootball: 'Гэльский футбол',
    handball: 'Гандбол',
    iceHockey: 'Хоккей',
    lacrosse: 'Лакросс',
    netball: 'Нетбол',
    other: 'Другое',
    padel: 'Падель',
    rugby: 'Регби',
    tennis: 'Теннис',
    volleyball: 'Волейбол'
  }
}
